import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs';
import { AuthStateService } from '../../services/auth-state.service';

const TILE_DATA = [
  {
    label: 'my_orders',
    icon: 'pi pi-shopping-cart',
    routerLink: ['/planning/orders'],
    roles: ['moderator', 'moderator_external', 'dispatcher', 'orderer'],
    right: 'admin.planning-orders.list'
  },
  {
    label: 'my_profile',
    icon: 'pi pi-user',
    routerLink: ['/my-profile'],
    roles: ['moderator', 'moderator_external', 'observer', 'observer_gem'],
  },
  {
    label: 'availabilities',
    icon: 'pi pi-calendar',
    routerLink: ['/my-availabilities'],
    roles: ['moderator', 'moderator_external', 'observer', 'observer_gem'],
  },
  {
    label: 'create_order',
    icon: 'pi pi-plus-circle',
    routerLink: ['/planning/orderform'],
    roles: ['orderer'],
  },
];

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  name: string = null;
  tiles: Array<any> = [];

  constructor(
    private router: Router,
    public auth: AuthStateService
  ) { }

  ngOnInit(): void {
    this.auth.userName$.subscribe(name => this.name = name);
    this.auth.hasHeader.pipe(
      take(1)
    ).subscribe((hasHeader: boolean) => {
      if (hasHeader !== true) {
        this.router.navigate(['/planning/orderform']);
      }
    });
    this.setTiles();
  }

  private setTiles(): void {
    const roles = this.auth.getRoles();
    TILE_DATA.forEach((entry: any) => {
      const entryRoles = entry.roles.filter((role: string) => roles.includes(role));
      if (entryRoles?.length > 0 && (entry.right === undefined || this.auth.hasRight(entry.right))) {
        this.tiles.push(entry);
      }
    });
  }

}
